export const MIN_REMOTE_QUERY_LENGTH = 2;
export const MAX_RESULTS = 12;

export function isCommandSearchShortcut(event) {
  return event.key?.toLowerCase() === "k" &&
    (event.metaKey || event.ctrlKey) &&
    !event.altKey;
}

export function platformModifierLabel(platform = "") {
  return /Mac|iPhone|iPad|iPod/i.test(platform) ? "⌘" : "Ctrl";
}

export function normalizeTransientNavigationState({ overlay, menu, menuButtons = [], body, previousBodyOverflow }) {
  if (overlay) overlay.hidden = true;
  menu?.classList.add("hidden");
  menuButtons.forEach((button) => button.setAttribute("aria-expanded", "false"));

  if (body && previousBodyOverflow !== undefined) body.style.overflow = previousBodyOverflow;
}

export function rankNavigationResults(pages, records, query, filter = "all") {
  const normalizedQuery = String(query || "").trim().toLowerCase();
  const candidates = normalizedQuery ? [...pages, ...records] : [...pages];

  return candidates
    .filter((result) => filter === "all" || result.type === filter)
    .map((result) => ({ result, score: resultScore(result, normalizedQuery) }))
    .filter(({ score }) => score !== null)
    .sort((left, right) => left.score - right.score || typeOrder(left.result.type) - typeOrder(right.result.type))
    .slice(0, MAX_RESULTS)
    .map(({ result }) => result);
}

function resultScore(result, query) {
  if (!query) return result.type === "page" ? 100 : null;

  const title = String(result.title || "").toLowerCase();
  const keywords = String(result.keywords || "").toLowerCase();
  const meta = String(result.meta || "").toLowerCase();

  if (title === query) return 0;
  if (title.startsWith(query)) return 10;
  if (title.includes(query)) return 20;
  if (keywords.split(/\s+/).some((keyword) => keyword.startsWith(query))) return 30;
  if (keywords.includes(query)) return 40;
  if (meta.includes(query)) return 50;

  return null;
}

function typeOrder(type) {
  return { page: 0, claim: 1, member: 2 }[type] ?? 3;
}
